module.exports = __webpack_public_path__ + "icomoon.b34b7651ab9934cabf19.svg";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/nova-icons/icomoon.svg?1qjem2
// module id = ../../../../../src/assets/custom-styles/fonts/nova-icons/icomoon.svg?1qjem2
// module chunks = 1